import { render, staticRenderFns } from "./GridReplacementsNew.vue?vue&type=template&id=458a3fb7&"
import script from "./GridReplacementsNew.vue?vue&type=script&lang=js&"
export * from "./GridReplacementsNew.vue?vue&type=script&lang=js&"
import style0 from "./GridReplacementsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports